(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sb-maerke-tags"] && !Shopify.designMode) return;
  try {
    
  /* Pilene: én side ad gangen; den pil, der ikke kan bruges, nedtones på samme plads */
  const sbmtOpd = (rk) => {
    const s = rk.closest('.sbmt'); if (!s) return;
    const [f, n] = s.querySelectorAll('.sbmt__pil');
    if (f) f.disabled = rk.scrollLeft <= 2;
    if (n) n.disabled = rk.scrollLeft + rk.clientWidth >= rk.scrollWidth - 2;
  };
  document.addEventListener('click', (e) => {
    const b = e.target.closest && e.target.closest('.sbmt__pil');
    if (!b) return;
    const rk = b.closest('.sbmt').querySelector('.sbmt__rk');
    rk.scrollBy({ left: Number(b.dataset.retning) * rk.clientWidth, behavior: 'smooth' });
  });
  document.addEventListener('scroll', (e) => { if (e.target.classList && e.target.classList.contains('sbmt__rk')) sbmtOpd(e.target); }, true);
  const sbmtAlle = () => document.querySelectorAll('.sbmt__rk').forEach(sbmtOpd);
  window.addEventListener('resize', sbmtAlle);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sbmtAlle); else sbmtAlle();
  document.addEventListener('shopify:section:load', sbmtAlle);

  /* Tastatur: rul det tag, der får fokus, helt ind i rullen (browseren nøjes med at vise en stump af det) */
  document.addEventListener('focusin', (e) => {
    const li = e.target.closest && e.target.closest('.sbmt__rk > li');
    if (li) li.scrollIntoView({ block: 'nearest', inline: 'nearest' });
  });

  } catch(e) { console.error(e); }
})();
})();
